import settings from '~/settings';
import { delay } from '~/helpers/delay';
import { actionsProcessing } from '~/Actions/ActionProcessing';

import type { IAppDispatch } from '..';

class GlobalSpinner {
  started = false;
  stopped = false;
  dispatch: IAppDispatch;
  text?: string;

  constructor(dispatch: IAppDispatch, text?: string) {
    this.dispatch = dispatch;
    this.text = text;
  }

  start = () => {
    if (!this.stopped) {
      this.dispatch(actionsProcessing.startFetching(this.text));
    }
    this.started = true;
  };

  stop = () => {
    if (this.started) {
      this.dispatch(actionsProcessing.stopFetching(this.text));
    }
    this.stopped = true;
  };
}

export const promiseWithGlobalSpinner = <T extends void>(
  dispatch: IAppDispatch,
  promise: Promise<T>,
  fetchingText?: string,
) => {
  const { start, stop } = new GlobalSpinner(dispatch, fetchingText);

  void delay(settings.fetchSpinnerDelay).then(start);

  promise.then(stop, stop);

  return promise;
};
